export default __webpack_public_path__ + "static/media/Playlist.06529cb6.svg";